import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import { to12Hr } from "../../../helpers/moment";
import { config } from "../../../config/index";
const { API_URL } = config;

const ShiftReminder130 = ({ history, notification }) => {
  const token = localStorage.getItem("token");

  const acknowledgeHandler = async () => {
    let url = `${API_URL}/notification/associate/${notification.id}/acknowledge`;

    try {
      let response = await fetch(url, {
        method: "PUT",
        withCredentials: true,
        mode: "cors",
        headers: {
          Authorization: token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json; charset=utf-8",
        },
      });

      let responseData = await response.json();

      if (response.ok) {
        // ToastUtil.success(responseData.message)
        window.location.reload();
      } else {
        ToastUtil.error(responseData.message);
      }
    } catch (error) {
      console.log(error);
      ToastUtil.error("Internal Server Error");
    }
  };

  return (
    <div className="container">
      <div
        className="py-4 text-muted text-center"
        style={{ fontSize: "0.8rem" }}
      >
        {moment(notification.createdAt).fromNow()},{" "}
        {to12Hr(moment(notification.createdAt))}
      </div>
      <h5>{notification.title}</h5>
      <div>
        Gentle reminder, your confirmed shift for today will start in 1.5 hr
        time. Please acknowledge this message to confirm your attendance.
      </div>

      <button
        className={
          "btn btn-block " +
          (notification && notification.is_acknowledged
            ? "btn-outline-brand"
            : "btn-brand")
        }
        disabled={notification && notification.is_acknowledged}
        onClick={acknowledgeHandler}
        style={{ marginTop: "100px" }}
      >
        Acknowledge{notification && notification.is_acknowledged && "d"}
      </button>
    </div>
  );
};

export default withRouter(ShiftReminder130);
